export const QA_NAME_CALENDAR_GRID_BLOCK = 'calendarGridBlock'
